import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { UserService } from '../../../services/user.service'
import { NavigationEnd, Router, RouterLink } from '@angular/router'
import { filter, Subscription } from 'rxjs'
import { NgOptimizedImage } from '@angular/common'

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [RouterLink, NgOptimizedImage],
    standalone: true,
})
export class HeaderComponent implements OnInit, OnDestroy {
    userService = inject(UserService)
    private router = inject(Router)

    subscription = new Subscription()
    userIsAdmin = toSignal(this.userService.isAdmin)
    isAdminPage = signal(false)

    ngOnInit(): void {
        this.userService.fetchIsAdmin().subscribe()
        this.isAdminPage.set(this.router.url.startsWith('/admin'))
        this.subscription.add(
            this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
                this.isAdminPage.set(this.router.url.startsWith('/admin'))
            }),
        )
    }

    ngOnDestroy() {
        this.subscription.unsubscribe()
    }
}
